"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _styles = require("@material-ui/core/styles");

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
      height: '100%'
    },
    title: {
      padding: '8px'
    }
  };
}); // deprecated

var WidgetNumber = function WidgetNumber(_ref) {
  var title = _ref.title,
      value = _ref.value,
      isPercentage = _ref.isPercentage;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_Paper["default"], {
    className: classes.paper,
    variant: "outlined"
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    className: classes.title,
    variant: "subtitle2",
    gutterBottom: true
  }, title), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "h5",
    gutterBottom: true
  }, value, isPercentage ? '%' : ''));
};

WidgetNumber.propTypes = {
  title: _propTypes["default"].string,
  value: _propTypes["default"].number,
  isPercentage: _propTypes["default"].bool
};
WidgetNumber.defaultProps = {
  title: 'Untitled',
  value: 'N/A',
  isPercentage: false
};
var _default = WidgetNumber;
exports["default"] = _default;